<template>
<div id="login">
    <v-app>
        <v-dialog v-model="dialog" persistent max-width="600px" min-width="360px">
            <div>
                <v-tabs v-model="tab" show-arrows background-color="deep-purple accent-4" icons-and-text dark grow>
                    <v-tabs-slider color="purple darken-4"></v-tabs-slider>
                    <v-tab v-for="i in tabs" :key="i.id" :disabled="i.disabled">
                        <v-icon large>{{ i.icon }}</v-icon>
                        <div class="caption py-1">{{ i.name }}</div>
                    </v-tab>
                    <v-tab-item>
                        <v-card class="px-4">
                            <v-card-text>
                                <v-form ref="loginForm" v-model="valid" lazy-validation> 
                                    <v-text-field v-model="login_1" :rules="loginRules" label="Логин" required></v-text-field> 
                                    <v-text-field v-model="pass_1" :append-icon="show1?'eye':'eye-off'" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Пароль" hint="Не менее 6 символов" counter @click:append="show1 = !show1"></v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-btn x-large block :disabled="!valid" color="success" @click="validate"> Войти </v-btn>   
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item>
                        <v-card class="px-4">
                            <v-card-text>
                                <v-form ref="registerForm" v-model="valid" lazy-validation>
                                    <v-text-field v-model="firstName" :rules="[rules.required]" label="First Name" maxlength="20" required></v-text-field>   
                                    <v-text-field v-model="lastName" :rules="[rules.required]" label="Last Name" maxlength="20" required></v-text-field> 
                                    <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                                    <v-text-field v-model="password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required, rules.min]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Password" hint="At least 8 characters" counter @click:append="show1 = !show1"></v-text-field> 
                                    <v-text-field block v-model="verify" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[rules.required, passwordMatch]" :type="show1 ? 'text' : 'password'" name="input-10-1" label="Confirm Password" counter @click:append="show1 = !show1"></v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-btn x-large block :disabled="!valid" color="success" @click="validate">Зарегистрироваться</v-btn>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>
                </v-tabs>
            </div>
        </v-dialog>
    </v-app>
</div>
</template>

<script>
  

export default {
    name: 'login',
    components: {
    },
    data() {
        return {
            dialog: true,
            tab: 0,
            tabs: [
                {id: 1, name:"Авторизация", icon:"mdi-account", disabled: false},
                {id:2, name:"Регистрация", icon:"mdi-account-outline", disabled: true}
            ],
            valid: true,    
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            verify: "",
            login_1: "",
            pass_1: "",
            loginEmailRules: [
                v => !!v || "Требуется ввод",
                v => /.+@.+\..+/.test(v) || "E-mail must be valid"
            ],
            loginRules: [
                v => /^[a-z0-9]+$/.test(v) || "латинские буквы и цифры",
                v => (v && v.length >= 5) || "мин. 5 символов"
            ],
            emailRules: [
                v => !!v || "Требуется ввод",
                v => /.+@.+\..+/.test(v) || "E-mail must be valid"
            ],
            show1: false,
            rules: {
                required: value => !!value || "Требуется ввод",
                min: v => (v && v.length >= 6) || "мин. 6 символов"
            } 
        }
    },
    computed: {
        passwordMatch() {
            return () => this.password === this.verify || "Password must match";
        }
    },
    methods: {
        validate() {
            if (this.$refs.loginForm.validate()) {
                // submit form to server/API here...
                //console.log('123')
                //console.log(this.login_1, this.pass_1)
                if(this.pass_1 === '1234567') {
                    this.$router.push('/');
                }
            }
        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        }
    },
}
</script>